{
  "navigation-back-button": {
    "text": {
      "back": "Zpět",
      "home-page": "Domovská stránka"
    }
  }
}
